import styled from '@emotion/styled';
import { Avatar, Box, Typography } from '@mui/material';

export const Title = styled(Typography)`
 padding-left: 8px;
 margin-bottom: -16px;
 z-index: 1;
 font-size: 2em;
 text-shadow: 2px 2px black;
`;

export const TableContainer = styled(Box)`
 padding-top: 24px;
`;

interface AvatarStyledProps {
  backgroundColor: string;
}

export const AvatarStyled = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "backgroundColor",
}) <AvatarStyledProps>`
  background-color:  ${({ backgroundColor }) => backgroundColor};
  height: 40px;
  width: 40px;

  & img {
    object-fit: contain;
    width: 80%;
    height: 80%;
  }
`


export const ImageMapContainer = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
 width: 80px;
 height: auto;
`;
